import { useTranslation } from 'react-i18next';
import * as S from '../../styles';

const ConsentLoading = () => {
  const [t] = useTranslation('calendar');

  return (
    <>
      <S.Title $align="center">{t('select-context.title')}</S.Title>
      <S.Paragraph $align="center">{t('select-context.loading')}</S.Paragraph>
    </>
  );
};

export default ConsentLoading;
